<template>
  <AppContainer id="movies" class="my-5">
    <b-form @submit.prevent="upload">
      <b-row>
        <b-col cols md="12" class="my-3">
          <h4 class="lead text-center">Add New Movie</h4>
        </b-col>
        <b-col cols md="12" class="ml-auto mr-auto">
          <b-row>
            <b-col cols md="4">
              <b-form-group id="input-group-1" label-for="title-input">
                <b-form-input
                  v-model.trim="movie.title"
                  id="title-input"
                  required
                  placeholder="Movie Title"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="4">
              <b-form-group label-for="genre-input">
                <b-form-input
                  v-model.trim="movie.genre"
                  id="genre-input"
                  required
                  placeholder="Movie Genre"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="4">
              <b-form-group label-for="rating-input">
                <b-form-input
                  v-model.trim="movie.rating"
                  id="rating-input"
                  required
                  placeholder="Movie Rating"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="4">
              <b-form-group label-for="time-input">
                <b-form-input
                  v-model.trim="movie.time"
                  id="time-input"
                  required
                  placeholder="Movie Time"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="4">
              <b-form-group label-for="schedule-input">
                <b-form-input
                  v-model.trim="movie.schedule"
                  id="schedule-input"
                  required
                  placeholder="Movie Schedule"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="4">
              <b-form-group label-for="release-input">
                <b-form-input
                  v-model.trim="movie.released"
                  id="release-input"
                  required
                  placeholder="Movie release"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="6">
              <b-form-group label-for="actors-input">
                <b-form-input
                  v-model.trim="movie.actors"
                  id="actors-input"
                  required
                  placeholder="Movie Actors"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="6">
              <b-form-group label-for="directors-input">
                <b-form-input
                  v-model.trim="movie.directors"
                  id="directors-input"
                  required
                  placeholder="Movie Directors"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="4">
              <b-form-group label-for="cinema-input">
                <b-form-input
                  v-model.trim="movie.cinema"
                  id="cinema-input"
                  required
                  placeholder="Movie Cinema"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="4">
              <b-form-group label-for="language-input">
                <b-form-input
                  v-model.trim="movie.languages"
                  id="language-input"
                  required
                  placeholder="Movie Language"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="4">
              <b-form-group label-for="thriller-input">
                <b-form-input
                  v-model.trim="movie.thriller"
                  id="thriller-input"
                  required
                  placeholder="Movie thriller"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="12">
              <b-form-group label-for="description-input">
                <b-form-input
                  v-model.trim="movie.description"
                  id="description-input"
                  required
                  placeholder="Movie Description"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols md="12" class="mb-1">
              <b-form-group id="input-group-1" label-for="picture-input">
                <b-form-file
                  accept="image/png, image/jpeg"
                  @change="handleFileChange($event)"
                ></b-form-file>
              </b-form-group>
            </b-col>

            <b-col cols md="12" class="mb-1">
              <section>
                <ul v-if="errors.length > 0">
                  <li v-for="(error, index) in errors" :key="index">
                    {{ error }}
                  </li>
                </ul>
              </section>
            </b-col>

            <b-col cols md="12" class="mb-1" v-show="showProgress">
              <h4 class="lead">Saving...</h4>
              <b-progress
                :value="progress"
                max="100"
                show-progress
                animated
              ></b-progress>
            </b-col>
          </b-row>

          <b-col cols md="12" class="my-1">
            <b-button type="submit" variant="primary" :disabled="!validate"
              >Save Movie</b-button
            >
          </b-col>
        </b-col>
      </b-row>
    </b-form>
  </AppContainer>
</template>

<script>
const AppContainer = () => import('@/core/Components/App/AppContainer.vue')
import { api } from '../../resource'
import axios from 'axios'
export default {
  name: 'movies-create',
  data() {
    return {
      results: null,
      errors: [],
      file: null,
      filesSelected: 0,
      cloudName: 'brandscinemas',
      preset: 'brandscinemas',
      tags: 'browser-upload',
      progress: 0,
      showProgress: false,
      fileContents: null,
      formData: null,
      movie: {
        title: '',
        imgurl: '',
        genre: '',
        rating: '',
        time: '',
        released: '',
        languages: '',
        actors: '',
        directors: '',
        description: '',
        cinema: '',
        thriller: '',
        schedule: ''
      }
    }
  },
  methods: {
    // function to handle file info obtained from local
    // file system and set the file state
    handleFileChange: function(event) {
      console.log('handlefilechange', event.target.files)
      //returns an array of files even though multiple not used
      this.file = event.target.files[0]
      this.filesSelected = event.target.files.length
    },
    prepareFormData: function() {
      this.formData = new FormData()
      this.formData.append('upload_preset', this.preset)
      this.formData.append('tags', this.tags) // Optional - add tag for image admin in Cloudinary
      this.formData.append('file', this.fileContents)
    },
    // function to handle form submit
    upload() {
      //no need to look at selected files if there is no cloudname or preset
      if (this.preset.length < 1 || this.cloudName.length < 1) {
        this.errors.push('You must enter a cloud name and preset to upload')
        return
      }
      // clear errors
      else {
        this.errors = []
      }
      console.log('upload', this.file.name)
      let reader = new FileReader()
      // attach listener to be called when data from file
      reader.addEventListener(
        'load',
        function() {
          this.fileContents = reader.result
          this.prepareFormData()
          let cloudinaryUploadURL = `https://api.cloudinary.com/v1_1/${this.cloudName}/upload`
          let requestObj = {
            url: cloudinaryUploadURL,
            method: 'POST',
            data: this.formData,
            onUploadProgress: function(progressEvent) {
              console.log('progress', progressEvent)
              this.progress = Math.round(
                (progressEvent.loaded * 100.0) / progressEvent.total
              )
              console.log(this.progress)
              //bind "this" to access vue state during callback
            }.bind(this)
          }
          //show progress bar at beginning of post
          this.showProgress = true
          axios(requestObj)
            .then(response => {
              this.results = response.data
              this.movie.imgurl = this.results.url
              api
                .create('movies/create', this.movie)
                .then(() => {
                  this.$swal('Success', 'Movie successfully saved!', 'Success')
                  this.reset()
                })
                .catch(e => {
                  this.$swal(e.body.status_message, e.body.data, 'error')
                })
            })
            .catch(error => {
              this.errors.push(error)
              console.log(this.error)
            })
            .finally(() => {
              setTimeout(
                function() {
                  this.showProgress = false
                }.bind(this),
                1000
              )
            })
        }.bind(this),
        false
      )
      // call for file read if there is a file
      if (this.file && this.file.name) {
        reader.readAsDataURL(this.file)
      }
    },
    reset() {
      this.movie.title = ''
      this.movie.genre = ''
      this.movie.rating = ''
      this.movie.languages = ''
      this.movie.actors = ''
      this.movie.directors = ''
      this.movie.time = ''
      this.movie.cinema = ''
      this.movie.description = ''
      this.movie.released = ''
      this.movie.schedule = ''
      this.movie.thriller = ''
      this.filesSelected = 0
      this.file = null
    }
  },
  components: {
    AppContainer
  },
  computed: {
    validate() {
      return (
        this.movie.title.length >= 3 &&
        this.movie.rating.length >= 1 &&
        this.movie.genre.length >= 3 &&
        this.movie.languages.length >= 3 &&
        this.movie.actors.length >= 3 &&
        this.movie.directors.length >= 3 &&
        this.movie.time.length >= 3 &&
        this.movie.cinema.length >= 3 &&
        this.movie.description.length >= 3 &&
        this.movie.released.length >= 3 &&
        this.movie.schedule.length >= 3 &&
        this.movie.thriller.length >= 3 &&
        this.filesSelected > 0
      )
    }
  }
}
</script>
